import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'booleanToYesNo'
})
export class BooleanToYesNoPipe implements PipeTransform {

  transform(value: boolean | null | undefined): string {
    if (value === true) {
      return 'Yes';
    } else if (value === false) {
      return 'No';
    }
    return ''; // Handle null or undefined values
  }

}
